<template>
  <div v-if="selected" class="decor-select" :tabindex="tabindex" @blur="open = false">
    <div class="selected pr-2" :class="{ open: open }" @click="open = !open">
      <div class="d-flex pa-1">
        <div class="mr-1 headline">{{ selected.name }}</div>
        <div :class="'font-size-2 ' + selected.name">ABCD 1234</div>
      </div>
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div
        class="item"
        v-for="(option, i) of options"
        :key="i"
        @click="
          open = false;
          selectFont(option)
        "
      >
        <template v-if="option.display != 0">
          <div :class="'d-flex pa-1 ' + (option.name == selected.name ? 'active' : '')">
              <div class="mr-1 headline">{{ option.name }}</div>
              <div :class="'font-size-2 ' + option.name">ABCD 1234</div>
          </div>
        </template>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    selected: {
      type: Object,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    selectFont: Function
  },
  data() {
    return {
      open: false,
    };
  },
  mounted() {
  },
  methods: {
    getPic(file_name) {
      return process.env.VUE_APP_IMAGE_FOLDER + file_name;
    }
  }
};
</script>

<style scoped>
.decor-select {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  min-height: 47px;
}

.decor-select .selected {
  background-color: #fff;
  border: 1px solid #a5a5a5;
  color: #000;
  cursor: pointer;
  user-select: none;
}

.decor-select .image-container {
  height: 75px;
  width: 75px;
  position: relative;
}

.decor-select img {
  padding: 1rem;
  max-width: 100%;
  max-height: 100%;
}

.decor-select .selected:after {
  position: absolute;
  content: "";
  top: 49%;
  right: 1em;
  width: 0;
  height: 0;
  border: 7.5px solid transparent;
  border-color: #000 transparent transparent transparent;
}

.decor-select .items {
  color: #fff;
  overflow: hidden;
  border-right: 1px solid #ddd;
  border-left: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  position: absolute;
  background-color: #fff;
  left: 0;
  right: 0;
  z-index: 1;
  max-height: 275px;
  overflow: scroll;
}

.decor-select .items div {
  color: #000;
  cursor: pointer;
  user-select: none;
}

.decor-select .item {
  border-bottom: 1px solid #ddd;
}

.decor-select .items div:hover {
  background-color: #c3d2d0;
}

.decor-select .d-flex {
  align-items: center;
}

.decor-select .headline {
  font-size: 1rem;
}

.decor-select .active {
  background: #e1efed;
}

.selectHide {
  display: none;
}
</style>
